<template>
	<div class="mtext">
		<div v-if="type == 1">
			<p style="font-weight: bolder;">预付说明：预付金额需满1000元可申请充值与提现。</p>
			<p>结算说明：</p>
			<p>1.一月一结算，每月10号开始结算上个月货款。</p>
			<p>2、每月10号开始出结算单,15号之前把所有的出完,请10号开始随时在系统里查看有没有账单。</p>
			<p>3、10号之前务必要把售后里的工单和结算月份及之前的售后处理完，不然也是要等处理完了才能结算，以免耽误结算时间。</p>
			<p>4、出过账单，在财务管理》账单管理操作结算单去结算，务必要核对下账号是否正确。第一次结算的，需要填写支付宝账号及姓名或银行账号及姓名开户行。如果货款需要充值到买家端余额的可直接填写金额。</p>
		</div>
		<div v-if="type == 2">
			<p>结算说明：</p>
			<p>1.一月一结算，每月15号开始出分销结算单,20号之前把所有的出完,请15号开始随时在系统里查看有没有账单。</p>
			<p>2、出过账单，在分销管理》分销账单操作结算单去结算，务必要核对下账号是否正确。第一次结算的，需要填写支付宝账号及姓名或银行账号及姓名开户行。如果货款需要充值到买家端余额的可直接填写金额。</p>
			<p>3.分销商结算金额须给公司开对应金额的发票。</p>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Mtext',
		data() {
			return {}
		},
		props: {
			type: { //用于回显
				type: Number,
				default: 1
			},
		},
	}
</script>

<style scoped lang="less">
	.mtext {
		width: 100%;
		display: flex;
		flex-direction: column;
	}
</style>


// WEBPACK FOOTER //
// src/common/mtext.vue